export default __webpack_public_path__ + "static/media/JBR.6905b046.webp";